export { generateBreadcrumbSchema } from './generate-breadcrumb-schema'
export { generateArticleSchema } from './generate-article-schema'
export { generatePersonSchema } from './generate-person-schema'
export { generateOrganizationSchema } from './generate-organization-schema'

export function generateGraphSchema (...schemas) {
  return {
    '@context': 'https://schema.org',
    '@graph': schemas,
  }
}
